import { setBedrockProviderModule } from "@caupulican/pi-ai";
import { bedrockProviderModule } from "@caupulican/pi-ai/bedrock-provider";

setBedrockProviderModule(bedrockProviderModule);
